import { render, staticRenderFns } from "./MobilePreventionEnvironmentRequest.vue?vue&type=template&id=4cd33810&scoped=true&"
import script from "./MobilePreventionEnvironmentRequest.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionEnvironmentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd33810",
  null
  
)

export default component.exports